export const Inception_Date = "1 Apr 2013";

export const CurrencyFormatter = value => {
  return Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR"
  }).format(value);
};

export const Date_Helper = () => {
  const date = new Date();
  return `${Inception_Date} - ${date.getDate()} ${date.toLocaleString(
    "default",
    {
      month: "short"
    }
  )} ${date.getFullYear()}`;
};

export const CATEGORY_LIMIT = 9;
